import { create } from 'zustand'
import { tenantAppCollect, tenantAppCollectList, tenantAppCollectRemove } from '@/services'
import { batchSave, cacheQuery } from '@/services/cache.ts'
import { getTodoCount, getTodoItem, getTodoList } from '@/services/workorder.ts'
import { WORK_ORDER_TABS } from '@/store/workOrder.ts'
import { getUser } from '@/common/utils.ts'

export enum COLLECT_TYPE {
  COMMONLY_USED = 'COMMONLY_USED',
  NAVIGATION = 'NAVIGATION',
}

const defaultState = {
  appLoading: false,
  navLoading: false,
  appCollectLoading: false,
  appType: null,
  appTypeList: [],
  appList: [],
  allApp: [],
  appNavDict: {},
  appCollectDict: {},
  appNav: [],
  appCommonlyUsed: [],
  todoList: [],
  menuCollect: [],
  workOrderData: {},
  appData: {},
  workOrderCount: {},
  workOrderTab: WORK_ORDER_TABS[0],
  workOrderNoMore: {},
  workOrderLoading: {},
  caasMenu: {},
}

const mergeDict = (originDict, list) => {
  const dict = list.reduce((result, item) => {
    result[item.appCode] = item.appCode
    return result
  }, {})
  return { ...originDict, ...dict }
}

let listFetchTimer: any = null

const COMMONLY_USED_MAX = 5
export const COLLECT_MENU_KEY = 'MAIN_COLLECT_MENU_KEY'
const useWorkshopStore = create((set, get: any) => ({
  ...defaultState,
  reset: () => set(() => ({ ...defaultState })),
  setAppType: appType => set({ appType }),
  setAppTypeList: appTypeList => set({ appTypeList }),
  setNavDict: appNavDict => set({ appNavDict }),
  setCollectDict: appCollectDict => set({ appCollectDict }),
  setAppList: appList => set({ appList }),
  setCaasMenu: caasMenu => set({ caasMenu }),
  setAllAppList: allApp => set({ allApp }),
  setAppLoading: appLoading => set({ appLoading }),
  fetchCollectList: async () => {
    set({ appCollectLoading: true })
    tenantAppCollectList(COLLECT_TYPE.COMMONLY_USED).then((appCommonlyUsed: any) =>
      set({
        appCollectLoading: false,
        appCollectDict: mergeDict({}, appCommonlyUsed),
        appCommonlyUsed:
          appCommonlyUsed.length > COMMONLY_USED_MAX
            ? appCommonlyUsed.slice(appCommonlyUsed.length - COMMONLY_USED_MAX)
            : appCommonlyUsed,
      })
    )
  },
  fetchNavList: async () => {
    set({ navLoading: true })
    return tenantAppCollectList(COLLECT_TYPE.NAVIGATION).then((appNav: any) => {
      // gougm  手动添加订单服务菜单
      // let orderNav = [
      //   {
      //     app: {
      //       appType: 'OFFICIAL',
      //       name:'订单服务'
      //     },
      //     appCode: 'order',
      //     createdBy: 'admin',
      //     createdTime: 1723875584000,
      //     id: '1824692567254654977',
      //     key: '1824692567254654977',
      //     label: '组织与权限',
      //     icon: null,
      //     lastUpdatedTime: 1723875584000,
      //     modifiedBy: 'admin',
      //     tenantId: 'shj_test',
      //     type: 'NAVIGATION',
      //     typeName: '导航',
      //     userId: '1',
      //   },
      // ]
      // appNav = appNav.concat(orderNav)
      set({ appNavDict: mergeDict({}, appNav), appNav, navLoading: false })
    })
  },
  fetchNav: async () => {
    const { fetchCollectList, fetchNavList } = get()
    fetchCollectList()
    fetchNavList()
  },
  navAdd: async record => {
    const { appNavDict, setNavDict, fetchNavList, appNav } = get()
    // const nextNav = [...appNav, record]
    // set({ appNav: nextNav })
    return tenantAppCollect(record.app.code, COLLECT_TYPE.NAVIGATION).then(() => {
      setNavDict({ ...appNavDict, [record.app.code]: record.app.code })
      return fetchNavList()
    })
  },
  navRemove: async code => {
    clearInterval(listFetchTimer)
    const { appNavDict, setNavDict, fetchNavList, appNav } = get()
    const nextNav = appNav.filter(d => d.app.code !== code)
    set({ appNav: nextNav })
    return tenantAppCollectRemove(code, COLLECT_TYPE.NAVIGATION).then(() => {
      const { [code]: _, ...rest } = appNavDict
      setNavDict(rest)
      listFetchTimer = setTimeout(fetchNavList, 300)
    })
  },
  setTodoList: async todoList => set({ todoList }),

  setMenuCollect: async menuCollect => {
    set({ menuCollect })
    const user = getUser()
    const key = `${COLLECT_MENU_KEY}_${user.id}`
    return batchSave([{ key, value: menuCollect.join(',') }])
  },

  getMenuCollect: async () => {
    const user = getUser()
    const key = `${COLLECT_MENU_KEY}_${user.id}`
    return cacheQuery([key]).then((res: any) => {
      const menuCollect = res[key]?.value?.split(',') || []
      set({ menuCollect })
    })
  },

  getWorkOrderData: async (itemKey, extra: any = {}) => {
    const { workOrderLoading, workOrderNoMore } = get()
    if (workOrderLoading[itemKey]) return
    const pageSize = 20
    set(state => ({ workOrderLoading: { ...state.workOrderLoading, [itemKey]: 1 } }))
    return getTodoItem({
      tab: itemKey,
      pageSize,
      ...extra,
      // minId: workOrderAppSelected?.id,
    })
      .then((res: any) => {
        let workOrderData = Array.from(res)

        set((state: any) => {
          if (extra.minId) {
            workOrderData = [...state.workOrderData[itemKey], ...workOrderData]
          }
          // state.workOrderLoading[itemKey] = false

          if (res?.length < pageSize) {
            state.workOrderNoMore[itemKey] = true
          }

          return {
            workOrderData: { ...state.workOrderData, [itemKey]: workOrderData },
            // workOrderLoading: { ...state.workOrderLoading },
            workOrderNoMore: { ...workOrderNoMore },
          }
        })
        return res
      })
      .finally(() => {
        set((state: any) => {
          return { workOrderLoading: { ...state.workOrderLoading, [itemKey]: 0 } }
        })
      })
  },

  setWorkOrderTab: workOrderTab => {
    set({ workOrderTab })
  },

  getAppData: async () => {
    getTodoCount().then(workOrderCount => {
      set({ workOrderCount })
    })
    return Promise.all(WORK_ORDER_TABS.map(tab => getTodoList({ tab }))).then(res => {
      set({
        appData: {
          [WORK_ORDER_TABS[0]]: res[0],
          [WORK_ORDER_TABS[1]]: res[1],
          [WORK_ORDER_TABS[2]]: res[2],
          [WORK_ORDER_TABS[3]]: res[3],
        },
      })
    })
  },

  getWorkOrderGroup: async () => {
    const { getWorkOrderData, getAppData } = get()
    getAppData()
    getWorkOrderData('TODO')
    getWorkOrderData('STARTER')
    getWorkOrderData('COMPLETED')
    getWorkOrderData(WORK_ORDER_TABS[3])
  },
}))

export default useWorkshopStore
